import type { WorkspaceRole } from "@/lib/login-session"

export type ExamUserRole = "Admin" | "Faculty" | "Student"

/** Map workspace sign-in role → Exam Management UI role. */
export function examRoleFromWorkspaceRole(workspaceRole: WorkspaceRole): ExamUserRole {
  if (workspaceRole === "student") return "Student"
  if (workspaceRole === "member") return "Faculty"
  return "Admin"
}

export function workspaceRoleFromExamRole(role: ExamUserRole): WorkspaceRole {
  if (role === "Student") return "student"
  if (role === "Faculty") return "member"
  return "administrator"
}

export const LOGIN_SESSION_CHANGED_EVENT = "exxat-login-session-changed"
